"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseHeader } from "../ModalBase/ModalBaseHeader.mjs";
import { useDrawerContext } from "./Drawer.context.mjs";
import Drawer_module_default from "./Drawer.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Drawer/DrawerHeader.tsx
const DrawerHeader = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("DrawerHeader", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseHeader, {
		...useDrawerContext().getStyles("header", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
DrawerHeader.classes = Drawer_module_default;
DrawerHeader.displayName = "@mantine/core/DrawerHeader";
//#endregion
export { DrawerHeader };

//# sourceMappingURL=DrawerHeader.mjs.map